define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');

    var Caller = require('./caller/index');
    var MissedCalls = require('./missedCalls/index');

    var template = require('text!./index.tpl').default;

    return Marionette.LayoutView.extend({
        template: template,
        className: 'b-notice',

        regions: {
            regionCaller        : '.js-caller-region',
            regionMissedCalls   : '.js-missed-calls-region'
        },

        onRender: function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            });
            this.regionCaller.show(new Caller());
            this.regionMissedCalls.show(new MissedCalls());
        }
    })
});